import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { capabilities } from '../../../data/capabilities';

const BenefitsGrid = () => {
  const [hoveredBenefit, setHoveredBenefit] = useState(null);
  const navigate = useNavigate();

  return (
    <section id="ozellikler" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
            <Icon name="Sparkles" size={16} />
            <span className="font-inter font-accent-medium text-sm">
              Platform Yetenekleri
            </span>
          </div>

          <h2 className="font-poppins font-heading-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-6">
            {capabilities?.length} Çalışan{' '}
            <span className="text-primary">Yetenek</span>
          </h2>

          <p className="font-open-sans font-body-normal text-xl text-text-secondary max-w-3xl mx-auto">
            Buradaki her madde bugün üründe var ve testten geçti. Yolda olanı "yakında" diye yazıyoruz,
            varmış gibi göstermiyoruz.
          </p>
        </div>

        {/* Capabilities Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {capabilities.map((benefit) => (
            <div
              key={benefit.id}
              className="group relative bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer border border-gray-100 hover:border-primary/20"
              onClick={benefit.href ? () => navigate(benefit.href) : undefined}
              role={benefit.href ? 'link' : undefined}
              onMouseEnter={() => setHoveredBenefit(benefit.id)}
              onMouseLeave={() => setHoveredBenefit(null)}
            >
              {/* Icon */}
              <div className={`w-14 h-14 ${benefit.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={benefit.icon} size={28} color="white" />
              </div>

              {/* Content */}
              <div className="space-y-3">
                <h3 className="font-poppins font-heading-semibold text-lg text-foreground group-hover:text-primary transition-colors duration-300">
                  {benefit.title}
                </h3>

                <p className="font-open-sans font-body-normal text-sm text-text-secondary leading-relaxed">
                  {benefit.description}
                </p>

                {/* Stat */}
                <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                  <div>
                    <p className="font-poppins font-heading-bold text-2xl text-primary">
                      {benefit.stat}
                    </p>
                    <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                      {benefit.statLabel}
                    </p>
                  </div>
                  <Icon name="ArrowUpRight" size={20} className="text-gray-400 group-hover:text-primary transition-colors duration-300" />
                </div>
              </div>

              {/* Hover Detail Overlay */}
              {hoveredBenefit === benefit.id && (
                <div className="absolute inset-0 bg-white rounded-2xl p-6 shadow-2xl border-2 border-primary/20 z-10 transform scale-105">
                  <div className="space-y-4">
                    <div className="flex items-center space-x-3">
                      <div className={`w-10 h-10 ${benefit.color} rounded-lg flex items-center justify-center`}>
                        <Icon name={benefit.icon} size={20} color="white" />
                      </div>
                      <div>
                        <h4 className="font-poppins font-heading-semibold text-sm text-foreground">
                          {benefit.detail.title}
                        </h4>
                        <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                          Nasıl çalışıyor
                        </p>
                      </div>
                    </div>

                    <div className="space-y-2">
                      {benefit.detail.points.map((point, index) => (
                        <div key={index} className="flex items-start space-x-2">
                          <div className="w-2 h-2 bg-primary rounded-full flex-shrink-0 mt-1.5"></div>
                          <span className="font-open-sans font-body-normal text-xs text-text-secondary leading-relaxed">
                            {point}
                          </span>
                        </div>
                      ))}
                    </div>

                    {benefit.href && (
                      <p className="inline-flex items-center gap-1 font-inter font-accent-semibold text-xs text-primary">
                        Ayrıntılar
                        <Icon name="ArrowRight" size={14} />
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 text-white">
            <h3 className="font-poppins font-heading-bold text-2xl mb-4">
              Tüm Özellikleri Canlı Olarak Görün
            </h3>
            <p className="font-open-sans font-body-normal text-lg opacity-90 mb-6 max-w-2xl mx-auto">
              15 dakikalık kişiselleştirilmiş demo ile işletmeniz için en uygun modülleri birlikte seçelim
            </p>

            <button
              onClick={() => window.open('https://panel.cafeotomasyonu.com/sign-up', '_blank')}
              className="inline-flex items-center space-x-2 bg-white text-primary px-8 py-4 rounded-xl font-poppins font-cta-semibold hover:bg-gray-100 transition-colors duration-300 shadow-lg"
            >
              <Icon name="Play" size={20} />
              <span>Ücretsiz Hesap Aç</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsGrid;
